import React, { useRef, useEffect, useState } from 'react';
import { FaceLivenessWebComponent } from '@regulaforensics/vp-frontend-face-components';
import { useNavigate } from "react-router-dom";
import   axios from "axios";
import KycShell from '../components/KycShell';

const Recognition = () => {
	const brandlogo = localStorage.getItem('brandlogo');
	const brandname = localStorage.getItem('brandname');
	const videoRef = useRef(null);
	const photoRef = useRef(null);
	const [happy, sethappy] = useState(false);
	let happypec = 0;
	let distance = 0;
	let matcher  =0;
	let unmatcher  =0;
	const [rightside, setrightside] = useState(false);
	const [leftside, setleftside] = useState(false);
	const [passportPhotodata, setpassportPhotodata] = useState('');
	let passportPhoto = localStorage.getItem('passportPhoto');
	const [smile, setsmile] = useState(false);
	const [started, setstarted] = useState(false);
	const [startedbtn, setstartedbtn] = useState(false);
	const [done, setDone] = useState(false);
	const [saved, setSaved] = useState(true);
	let right =false;
	let left = false ;
	const [Rightdirct, SetphotoRight] = useState('');
	const [match, setmatch] = useState('');
	const [Distance, setdistance] = useState('');
	const [leftdirct, SetphotoLeft] = useState('');
	const [Smilephoto, setsmillephoto] = useState('');
	const address_proof = localStorage.getItem('address_proof');

	const [btn , setbtn] = useState("btn btn-primary");
	const [btntxt , setbtntxt] = useState("Start Now");
	const [disabledbtn, setdisabled] = useState(false);

	const [btnicon , setbtnicon] = useState("fa-solid fa-arrow-right");
	const [isOpen, setIsOpen] = useState(false);
	const containerRef = useRef(null);
	const componentRef = useRef(null);
	const [livenessResult, setLivenessResult] = useState(null);

	const navigate = useNavigate();
	let  uuid;

	let Selectedcountry ,ipAdress,passportName,passportsurname,birthday,passportcountry,Gender,passportNumber,passportexpire,proofName,proofIssuerAddress,proofIsuueName,proofReciptAddress,proofDate,proofPhoto,proofDate_1,userAgent,passportPhoto_back,setdocumenttitle;

	const getData =()=>{
		setdocumenttitle = localStorage.getItem('setdocumenttitle');
		userAgent = localStorage.getItem('userAgent');
		Selectedcountry = localStorage.getItem('Selected-country');
		ipAdress = localStorage.getItem('Ip-Adrees');
		passportPhoto = localStorage.getItem('passportPhoto');
		passportPhoto_back = localStorage.getItem('passportPhoto_back');
		uuid = localStorage.getItem('uuid');
		proofPhoto = localStorage.getItem('proofPhoto');
	}

	const listener = (data) => {

    if (data.detail.action === 'PROCESS_FINISHED')
	{
			if((data.detail.data.status === 1 && data.detail.data.response))
			{
				getData();
				let postdata = JSON.stringify({
					"type":setdocumenttitle,
					"country": Selectedcountry,
					"uuid":uuid,
					"passportPhoto": passportPhoto,
					"passportPhoto_back": passportPhoto_back,
					"proofphoto":proofPhoto,
					"userAgent": userAgent,
					"ip_address": ipAdress,
					"rightsidephot": '',
					"leftsidephoto": '',
					"match": '',
					"distance": '',
					"smilephoto": data.detail.data.response.capture[0]
				});
				let config = {
					method: 'post',
					'mode':'cors',
					url: 'https://kyc2.codegotech.com/send_profile',
					headers: {
						'Content-Type': 'application/json'
					},
					data : postdata
				};

				axios.request(config).then((response) => {
						localStorage.removeItem('setdocumenttitle');
						localStorage.removeItem('userAgent');
						localStorage.removeItem('Selected-country');
						localStorage.removeItem('Ip-Adrees');
						localStorage.removeItem('proofPhoto');
						localStorage.removeItem('passportPhoto');
						localStorage.removeItem('uuid');

						localStorage.removeItem('setapipassport');
						localStorage.removeItem('setapicountryname');
						localStorage.removeItem('setidcard');
						localStorage.removeItem('setdriverlicense');
						localStorage.removeItem('setpermitresidence');

						localStorage.removeItem('front_back');
						localStorage.removeItem('passport_type');
						localStorage.removeItem('idcard_type');
						localStorage.removeItem('driver_license_type');
						localStorage.removeItem('permit_residence_type');
						localStorage.removeItem('passportPhoto_back');

						localStorage.removeItem('address_proof');
						navigate('/process');
				}).catch((error) => {
					let mrz_data_element = document.getElementById('div_msgs');
					mrz_data_element.innerHTML = error;
				});
			}else{

			}
    }

    if (data.detail?.action === 'CLOSE' || data.detail?.action === 'RETRY_COUNTER_EXCEEDED') {
      setIsOpen(false);
    }
	};


	useEffect(() => {



		if (isOpen && componentRef.current) {
		  componentRef.current.settings = {
			locale: 'en',
			videoRecording: false,
			//url: 'https://faceapi.regulaforensics.com/',
			url: 'https://facesdk.codegotech.com/',
			headers: {
				Authorization: 'Basic QWxhZGRpbjpvcGVuIHNlc2FtZQ==',
			},
			tag: '123',
			customization: {
				fontFamily: 'Inter, sans-serif',
				fontSize: '16px',
				onboardingScreenStartButtonBackground: '#2563EB',
				onboardingScreenStartButtonBackgroundHover: '#1D4ED8',
				onboardingScreenStartButtonTitle: '#FFFFFF',
				onboardingScreenStartButtonTitleHover: '#FFFFFF',
				cameraScreenFrontHintLabelBackground: '#E8E8E8',
				//onboardingScreenIllumination: 'https://path-to-image.com',
				//onboardingScreenAccessories: 'data:image/svg+xml;base64,PHN2...',
				//onboardingScreenCameraLevel: importedImage,
				cameraScreenFrontHintLabelText: '#0F172A',
				cameraScreenSectorActive: '#2563EB',
				cameraScreenSectorTarget: '#BFDBFE',
				cameraScreenStrokeNormal: '#2563EB',
				processingScreenProgress: '#2563EB',
				retryScreenRetryButtonBackground: '#2563EB',
				retryScreenRetryButtonBackgroundHover: '#1D4ED8',
				retryScreenRetryButtonTitle: '#FFFFFF',
				retryScreenRetryButtonTitleHover: '#FFFFFF',
			},
		  };
		}
	}, [isOpen]);

  useEffect(() => {

	  //load();
	let uuids = localStorage.getItem('uuid');
	if(uuids === null)
	{
	  //console.log(uuids);
	  navigate('/');
	}

    const containerCurrent = containerRef.current;

    if (!containerCurrent) return;

    containerCurrent.addEventListener('face-capture', listener);

    return () => {
      containerCurrent.removeEventListener('face-capture', listener);
    };
  }, []);
	return (
    <KycShell step={3} brandName={brandname}>
        <div id="div_msgs" style={{ color: 'var(--kyc-danger)', fontSize: 13, fontWeight: 500 }} />
        <div className="kyc-card">
            <div className="kyc-card__eyebrow">Face liveness</div>
            <h1 className="kyc-card__title">Verify it's really you</h1>
            <p className="kyc-card__subtitle">
                Follow the on-screen prompts to complete a quick liveness check.
                Make sure your face is well lit and remove glasses or hats.
            </p>

            <div className="kyc-liveness-shell" ref={containerRef}>
                {isOpen ? (
                    <face-capture ref={componentRef} />
                ) : (
                    <div className="kyc-liveness-illu">
                        <div className="kyc-liveness-illu__icon">
                            <i className="fa fa-smile-o" aria-hidden="true"></i>
                        </div>
                        <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>Ready when you are</h3>
                        <p style={{ margin: 0, fontSize: 14, color: 'var(--kyc-text-secondary)', maxWidth: 320 }}>
                            Scan your face to verify your identity.
                        </p>
                        <button
                            className="kyc-btn kyc-btn-primary"
                            onClick={() => setIsOpen(true)}
                            style={{ maxWidth: 260 }}
                        >
                            Start liveness <i className={btnicon} style={{ marginLeft: 8 }}></i>
                        </button>
                    </div>
                )}
            </div>
        </div>
    </KycShell>
	);
};
export default Recognition;
